import Vue from 'vue'
import Vuex from 'vuex'
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  street_name: payload.street_name,
  street_number: payload.street_number,
  city: payload.city,
  state: payload.state,
  country: payload.country,
  address_type_id: payload.address_type_id,
  customer_id: payload.customer_id
})
var crud = new Crud('AddressTypes', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  addressTypes: [],
  catalog: {
    addressTypes: []
  }
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  addressTypes: state => state.addressTypes
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
